import { render, staticRenderFns } from "./lb-column.vue?vue&type=template&id=9d66f68c&"
import script from "./lb-column.vue?vue&type=script&lang=js&"
export * from "./lb-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports